export default __webpack_public_path__ + "static/27637-4adfe3444f84d057edc14427c0822168.jpg";